import PropTypes from 'prop-types'
import { gql } from '@apollo/client'
import groupFragment, { groupFragmentPropTypes } from '~/graphql/fragments/group'

const thumbnailEventCollection = gql`
  fragment thumbnailEventCollection on ThumbnailEventCollection {
    id
    type
    status
    title
    subtitle
    group {
      ...group
    }
  }

  ${groupFragment}
`

export const thumbnailEventCollectionPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['ACTIVE', 'PREVIEW']).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  group: groupFragmentPropTypes.isRequired,
})

export default thumbnailEventCollection
